/**
 * `getTemplateTitle` で削除判定できたテンプレート ID を保持し、
 * 不要な `templates/:templateId` / `templates` 取得を抑止するための軽量なメモリ内ポリシー。
 *
 * 目的:
 * - 削除済みテンプレートに対する 404 確定リクエストを事前に回避する
 * - ドキュメント編集画面内でのみ有効な一時状態として扱う
 */
let deletedTemplateId: string | undefined;

/**
 * テンプレートごとの削除状態を更新し、関連する一覧取得スキップ状態も同期する。
 */
export function updateTemplateFetchPolicy(templateId: string, isDeleted: boolean) {
    if (isDeleted) {
        deletedTemplateId = templateId;
    } else {
        deletedTemplateId = undefined;
    }
}

/**
 * ポリシーをリセットし、削除済みテンプレート判定を解除する。
 */
export function clearTemplateFetchPolicy() {
    deletedTemplateId = undefined;
}

/**
 * 指定テンプレートIDが削除済みとして判定済みかを返す。
 */
export function isDeletedTemplateId(templateId: string): boolean {
    return deletedTemplateId === templateId;
}

/**
 * テンプレート一覧取得をスキップすべき状態かを返す。
 */
export function shouldSkipTemplateListDefinitionsFetch(): boolean {
    return deletedTemplateId !== undefined;
}
